module.exports = __webpack_public_path__ + "static/media/vitez_user_app.92fe18a3.png";